/* eslint-disable no-unused-vars */
import React from 'react';
import {Video, Title, Slideshow} from './../../Basics';
import Particle from './../../Particle';
/* eslint-enable no-unused-vars */

const Particle27 = () => (<div>

  <Title>So knapp siegte das Schweizer Team</Title>




  <Video
    source={require('./27_Siegervideo.mp4')}
    poster={require('./P27_preview.png')}
  />


  <Particle
    number={3}
  />

</div>);

export default Particle27;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle27/Particle27.js
 **/